// extracted by mini-css-extract-plugin
module.exports = {"container":"MinMax_container__tj4qH","maxInput":"MinMax_maxInput__mvVtM","minInput":"MinMax_minInput__DEdbP"};